import { useTranslation } from 'react-i18next';
import { Link } from '@inertiajs/react';
import { cn } from '../../lib/cn';

const typeColors = {
  prefix: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300 border-blue-200 dark:border-blue-800',
  root: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300 border-amber-200 dark:border-amber-800',
  suffix: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300 border-green-200 dark:border-green-800',
  bound: 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300 border-purple-200 dark:border-purple-800',
  infix: 'bg-pink-100 text-pink-800 dark:bg-pink-900/30 dark:text-pink-300 border-pink-200 dark:border-pink-800',
};

function useTypeLabels() {
  const { t } = useTranslation();
  return {
    prefix: t('morphemes.prefix'),
    root: t('morphemes.root'),
    suffix: t('morphemes.suffix'),
    bound: t('morphemes.bound'),
    infix: t('morphemes.infix'),
  };
}

export default function MorphemeBreakdown({ morphemes, showMeaning = true, className }) {
  const typeLabels = useTypeLabels();
  if (!morphemes || morphemes.length === 0) return null;

  return (
    <div className={cn('flex flex-wrap items-start gap-1', className)}>
      {morphemes.map((m, idx) => (
        <Link
          key={idx}
          href={m.id ? `/teacher/morphemes/${m.id}` : '#'}
          className="flex flex-col items-center group"
        >
          <span
            className={cn(
              'px-3 py-2 rounded-lg font-mono text-sm border transition-shadow group-hover:shadow-md',
              typeColors[m.type] || 'bg-gray-100 text-gray-800 border-gray-200'
            )}
          >
            {m.morpheme}
          </span>
          {showMeaning && m.meaning && (
            <span className="text-xs text-gray-500 dark:text-gray-400 mt-1 text-center max-w-20 transition-all duration-200 group-hover:text-gray-700 dark:group-hover:text-gray-200 group-hover:drop-shadow-[0_0_4px_rgba(0,0,0,0.15)] dark:group-hover:drop-shadow-[0_0_4px_rgba(255,255,255,0.25)]">
              {m.meaning}
            </span>
          )}
          <span className="text-xs text-gray-400 dark:text-gray-500 mt-0.5">
            {typeLabels[m.type] || m.type}
          </span>
        </Link>
      ))}
    </div>
  );
}
